import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import Icon from 'components/Icon';
import Thumbnail from 'components/Thumbnail';

import { FilePropType } from 'propTypes/common';

import styles from '../styles.module.scss';

const VirtualTour = ({ thumbnailFile, url, title }) => (
	<a
		href={url}
		className={cx(styles.item, styles.overlay)}
		style={{
			width: `${(23 * thumbnailFile.width) / thumbnailFile.height}em`
		}}
		target="_blank"
		rel="noopener"
	>
		{title && <div className={styles.title}>{title}</div>}
		<Thumbnail file={thumbnailFile} className={styles.image} />
		<div className={styles.iconWrapper}>
			<Icon className={cx(styles.icon, styles.tours)} icon="media-tours" />
		</div>
	</a>
);

VirtualTour.propTypes = {
	thumbnailFile: FilePropType.isRequired,
	url: PropTypes.string.isRequired,
	title: PropTypes.string
};

export default VirtualTour;
